module.exports = __webpack_public_path__ + "static/media/SG-SNI4_1kpXzr_vGy_gWtPr7eVwMCoLSlsKBWtEI.956a3584.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/SG-SNI4_1kpXzr_vGy_gWtPr7eVwMCoLSlsKBWtEI
// module id = 673
// module chunks = 0